import React from 'react';
import AddRegisterButton from "../../components/popUpMenu/addRegisterButton";

export const getCustomCardButtons = (projectData) => {
    const customCardsOptions = [];
    for (const customcardData of Object.values(projectData.customcards)) {
        if (customcardData.attributes.gps || customcardData.attributes.appartment_id) {
            customCardsOptions.push({
                id: customcardData.id,
                name: customcardData.attributes.name,
                protocol_id: customcardData.attributes.protocol_id
            });
        }
        
    }

    let buttonsToRender = []
    for (const customCardData of customCardsOptions) {
        buttonsToRender.push(<AddRegisterButton key={customCardData.id} properties={customCardData}></AddRegisterButton>)
    }
    return buttonsToRender
}